import {
  Checkbox,
  GridItem,
  HStack,
  SimpleGrid,
  useBreakpointValue,
} from '@chakra-ui/react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { SourcesResponse } from '../../interfaces'
import { InfoPopover } from './InfoPopover'
import { OriginFormInput } from './OriginFormInput'

interface Props {
  name: string
  textFieldName?: string
  label: string
  info: string
  values: SourcesResponse
  isDisabled?: boolean
}

const OriginFormCheckbox = ({
  name,
  textFieldName,
  label,
  info,
  values,
  isDisabled,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const colSpan = useBreakpointValue({ base: 2, xl: 1 })

  return (
    <React.Fragment>
      <Field>
        {({ form }: FieldProps<string, SourcesResponse>) => (
          <HStack>
            <Checkbox
              id={name}
              name={name}
              isChecked={form.values[name]}
              onChange={form.handleChange}
              isDisabled={isDisabled}
            >
              {label}
            </Checkbox>
            <InfoPopover info={info} />
          </HStack>
        )}
      </Field>
      {values[name] && textFieldName && name === 'includeCanonicalHeader' && (
        <SimpleGrid columns={2} columnGap={40} width="full">
          <GridItem colSpan={colSpan}>
            <OriginFormInput
              name={textFieldName}
              label={t(
                'base_url_for_canonical_header',
                'Base URL for Canonical Header',
              )}
              required={values[name]}
              isDisabled={isDisabled}
            />
          </GridItem>
        </SimpleGrid>
      )}
    </React.Fragment>
  )
}

export default OriginFormCheckbox
